import { useCallback } from "react";

export const useScrollTo = () => {
  return useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);
};
